import { useState, useContext, useEffect } from "react";
import { getCachedData, setCachedData } from "../utils/apiCache";
import { ProductContext } from "../context/AppContext";
import Header from "./Header";
import Swal from "sweetalert2";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Modal,
  Spinner,
} from "react-bootstrap";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { Link } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import { QrReader  } from 'react-qr-reader';
import { QRCodeSVG } from 'qrcode.react';

function LibraryBooks() {
  const { userId, GetstudentData  } = useContext(ProductContext);
  const routes = all_routes;

  const [getLibrary, setGetLibrary] = useState([]);
  const StudentId = GetstudentData?.id;

  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showQRScannerId, setShowQRScannerId] = useState(null);

    const authtoken = localStorage.getItem("token");

  const fetchStudentGatePassData = async () => {
    const cacheKey = 'library_books';
    const cached = getCachedData(cacheKey);
    if (cached) {
      setGetLibrary(cached);
    }
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/transport/book-details`,
        {
          headers: {
            "x-auth": authtoken,
          },
        }
      );
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch Visitor1 data");
      }
      setGetLibrary(data);
      setCachedData(cacheKey, data);
    } catch (error) {
      console.error("Error fetching Visitor1 data:", error);
    }
  };

  useEffect(() => {
    fetchStudentGatePassData();
  }, [userId]);

  console.log(getLibrary, "getLibrary 1500");

  const QRCodeScanner = ({ visitorId }) => {
    const [scannedId, setScannedId] = useState(null);

    const handleScan = (data) => {
      if (data) {
        try {
          const parsed = JSON.parse(data);
          setScannedId(parsed.id || data);
        } catch {
          setScannedId(data); // fallback if not JSON
        }
      }
    };

    const handleError = (err) => {
      console.error("QR Scan Error:", err);
    };

    return (
      <div style={{ textAlign: "center", padding: "10px" }}>
        <h6>Scanning for ID: {visitorId}</h6>
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: "100%" }}
        />
        {scannedId && (
          <div style={{ marginTop: "10px", fontWeight: "bold" }}>
            ✅ Scanned ID: {scannedId}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <Header />

        

        <Container fluid>
          <div className="d-flex justify-content-between align-items-center my-2 pb-2">
            <h2
              className="page-title fw-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>Library</h2>
          <Link to={`${routes.libraryissuedbook}`} state={{ getLibrary: getLibrary }}>
            <Button
              variant="primary"
              style={{ height: "45px", marginLeft: "20px" }}
            >
              Issued Book
            </Button>
          </Link>
        </div>
          <Row className="justify-content-left">
            {getLibrary?.data?.length > 0 ? (
              getLibrary?.data
                ?.sort(
                  (a, b) => new Date(b.created_at) - new Date(a.created_at)
                )
                .map((librarydata, index) => (
                  <Col
                    md={3}
                    lg={3}
                    className="mb-3 justify-content-center"
                    key={librarydata.id}
                  >
                    <Card className="shadow-sm border-0">
                      {librarydata.cover_image ? (
                        <div>
                          <img
                            src={librarydata.cover_image}
                            alt="librarydata Document"
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "contain",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setSelectedImage(librarydata.cover_image);
                              setShowImageModal(true);
                            }}
                          />
                        </div>
                      ) : (
                        <ImageWithBasePath
                          src="assets/img/sending-img.png"
                          className="img-fluid"
                          alt="img"
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "contain",
                            cursor: "pointer",
                          }}
                        />
                      )}

                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          padding: "8px",
                          fontSize: "0.9rem",
                        }}
                      >
                        <div className="StudentGateClass_1">
                          <strong>ID:</strong>
                          <span> {librarydata?.id}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Auther name:</strong>
                          <span> {librarydata.author_name}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Edition:</strong>
                          <span> {librarydata.edition}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Language:</strong>
                          <span> {librarydata.language}</span>
                        </div>
                        <div className="StudentGateClass_1">
                          <strong>Total Quantity:</strong>
                          <span> {librarydata.total_quantity}</span>
                        </div>
                        {librarydata.available_quantity && (
                        <div className="StudentGateClass_1">
                          <strong>Available Quantity:</strong>{" "}
                          <span>{librarydata.available_quantity}</span>
                        </div>
                        )}
                        {librarydata.quantity_alert && (
                        <div className="StudentGateClass_1">
                          <strong>Quantity Alert:</strong>
                          <span> {librarydata.quantity_alert}</span>
                        </div>
                        )}

                        <div className="StudentGateClass_1">
                          <strong>Publisher Name:</strong>{" "}
                          <span>{librarydata.publisher_name}</span>
                        </div>
                        

                        {/* <div className="StudentGateClass_1">
                          <strong>Status:</strong>
                          <span
                            style={{
                              marginBottom: "0",
                              color:
                                Visitor1.status === "approved"
                                  ? "green"
                                  : Visitor1.status === "pending"
                                  ? "orange"
                                  : "black",
                            }}
                          >
                            {Visitor1.status}
                          </span>
                        </div>
                        {Visitor1.status === "approved" && (
  <div className="StudentGateClass_21 mt-2">
    <Button
      variant="primary"
      onClick={() =>
        setShowQRScannerId(
          showQRScannerId === Visitor1.id ? null : Visitor1.id
        )
      }
      className="float-end"
    >
      {showQRScannerId === Visitor1.id
        ? "Hide QR Code"
        : "Generate QR Code"}
    </Button>

    {showQRScannerId === Visitor1.id && (
      <div className="mt-3 text-center">
        <h2>Id : {Visitor1.id}</h2>
        <QRCodeSVG
          value={JSON.stringify({ id: Visitor1.id })}
          size={128}
          level="H"
          includeMargin={true}
        />
        <div className="mt-2">
          <small>Scan this QR at the gate</small>
        </div>
      </div>
    )}
  </div>
)}
                        {!Visitor1?.out_time ||
                        Visitor1?.out_time?.length === 0 ? (
                          <div className="StudentGateClass_21 mt-2">
                            <Link
                              to={`${routes.StudentUpdateGatePass}/${Visitor1.id}`}
                            >
                              <Button
                                variant="primary"
                                style={{ float: "right" }}
                              >
                                <span>Update</span>
                              </Button>
                            </Link>
                          </div>
                        ) : null} */}
                      </div>
                    </Card>
                  </Col>
                ))
            ) : (
              <div className="content row d-flex justify-content-center align-items-center background-color_row_1">
                <Header />
                <ImageWithBasePath
                  src="assets/img/nodata.gif"
                  className="img-fluid"
                  alt="img"
                  width={200}
                />
              </div>
            )}
          </Row>
        </Container>

        <Modal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>View Document</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Document"
                style={{ width: "100%", height: "auto" }}
              />
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default LibraryBooks
